define('lq/events/actions/businessLogicBlockCommand',[
    'underscore',
    'lq/events/actions/eventAction'
], function (_, EventAction) {
    'use strict';

    function BusinessLogicBlockCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(BusinessLogicBlockCommand, EventAction);

    BusinessLogicBlockCommand.typeName = 'BusinessLogicBlockCommand';

    BusinessLogicBlockCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    BusinessLogicBlockCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'BusinessLogicBlockCommand',
            command: this.eventData.command
        };
    };

    BusinessLogicBlockCommand.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;

        var firstContinuation = _.reduce(eventActionResponse.Events.reverse(), function (nextContinuation, theEvent) {
            return function () {
                var eventName = theEvent.EventName.charAt(0).toLowerCase() + theEvent.EventName.slice(1)
                self.triggerEvent(eventName, nextContinuation, theEvent.Value);
            }
        }, continuation);

        firstContinuation();
    };

    return BusinessLogicBlockCommand;
});
